declare global {
    interface Window {
        _env_?: {
            REACT_APP_OIDC_REALM?: string;
            REACT_APP_API_HOST?: string;
        };
    }
}

function getEnv(key: string, fallback: string = ''): string {
    return window._env_?.[key as keyof typeof window._env_]
        || process.env[key]
        || fallback;
}

export const config = {
    oidcRealm: getEnv('REACT_APP_OIDC_REALM', 'CppModel'),
    apiHost: getEnv('REACT_APP_API_HOST'),
    oidcAuthority: `https://auth.cppmodel.com/realms/${getEnv('REACT_APP_OIDC_REALM', 'CppModel')}`,
    oidcClientId: 'cppmodel-frontend',
};
